<template>
    <div class="camInfoWrapper">
        <div class="camInfoTop">
            <div class="camInfoLeft">
                <div class="campaignName">
                    {{ campaignInfo.campaign_nm }}
                    <img
                        class="export_excel"
                        id="export_excel"
                        :title="excel"
                        src="../../../assets/excel-icon.png"
                        @click="exportTable"
                        alt="export_xls"
                    />
                </div>
                <div class="campaignStatus">
                    <div class="statusText" :class="camStatus">
                        {{ status }}
                    </div>
                    {{ periodData }}
                </div>
            </div>
            <div class="camInfoRight">
                <div class="camInfoCompany">
                    <span>광고주 </span>
                    <span>{{ campaignInfo.client_nm }}</span>
                </div>
                <div class="camInfoCompany" v-if="cust_knd.a">
                    <span>에이전시 </span>
                    <span>{{ campaignInfo.agency_nm }}</span>
                </div>
                <div class="camInfoCompany" v-if="cust_knd.l">
                    <span>렙사 </span>
                    <span>{{ campaignInfo.lab_cust_nm }}</span>
                </div>
            </div>
        </div>
        <div class="camInfoBottom">
            <v-progress-linear
                :title="progressText"
                v-model="initProgress"
                :height="10"
            ></v-progress-linear>
            <div class="progressInfo">
                <span>{{ parseDateFormat(ymd.fr) }}</span>
                <span>{{ parseDateFormat(ymd.to) }}</span>
            </div>
        </div>
        <ExcelTable
            :campaignType="campaignType"
            :checkDate="checkDate"
        ></ExcelTable>
        <iframe id="exportIE"></iframe>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { mapState, mapGetters } from 'vuex'
    import { checkUser, parseDateFormat, parseDate, exprtExcel } from '@/assets/func'
    import ExcelTable from '@/components/campaign/excelContent/ExcelTable'

    export default {
      name: 'campaignInfo',
      props: {
        campaignType: String,
        isInterPlay: Boolean,
        checkDate: Function
      },
      data () {
        return {
          cust_knd: '',
          initProgress: 0,
          live_days: 0,
          total_days: 0,
          excel: 'Excel Download'
        }
      },
      components: {
        ExcelTable
      },
      methods: {
        calDays (frDay, toDay) { // 입력 받은 두 날짜 차이 계산(일 단위)
          let diffDate1 = frDay instanceof Date ? frDay : new Date(frDay)
          let diffDate2 = toDay instanceof Date ? toDay : new Date(toDay)

          diffDate1 = new Date(diffDate1.getFullYear(), diffDate1.getMonth(), diffDate1.getDate())
          diffDate2 = new Date(diffDate2.getFullYear(), diffDate2.getMonth(), diffDate2.getDate())
          let diff = Math.abs(diffDate2.getTime() - diffDate1.getTime())
          diff = Math.ceil(diff / (1000 * 3600 * 24))
          return diff
        },
        getProgressToDate () { // progress bar에 표시할 현재 날짜 or 종료 날짜 확인 및 format변경
          if (this.campaignInfo.status === '4') {
            return this.ymd.to
          }

          let today = new Date()
          let y = today.getFullYear() + ''
          let m = today.getMonth() + 1 + ''
          let d = today.getDate() + ''

          if (m < 10) m = '0' + m
          if (d < 10) d = '0' + d

          return y + m + d
        },
        parseDate (str) { // (20170101 => new date(2017, 01, 01))
          return parseDate(str)
        },
        parseDateFormat (str) { // (20170101 -> '2017-01-01')
          return parseDateFormat(str)
        },
        queryAndIndeterminate () { // 컴포넌트 마운트 된 후 progress bar가 채워질때까지의 intervla
          this.interval = setInterval(() => {
            this.initProgress = this.Progress
          }, 100)
        },
        exportTable (e) {
          exprtExcel(this.xlsTableNames, this.campaignInfo.campaign_nm)
        }
      },
      computed: {
        ...mapState({
          campaignInfo: state => state.campaign.campaignInfo,
          campaignDetailTap: state => state.campaign.campaignDetailTap,
          creativeData: state => state.campaign
        }),
        ...mapGetters([
          'getInfoLength'
        ]),
        camStatus () {
          switch (this.campaignInfo.status) {
            case '2':
              return 'text-blue'
            case '4':
              return 'text-green'
            case '3':
            case '5':
              return 'text-red'
            default:
              return 'text-black'
          }
        },
        progressText () { // progress bar 마우스 올렸을때 보여줄 내용
          let toDate = this.getProgressToDate()
          return '진행률 : ' + this.ymd.fr + ' ~ ' + toDate + ' (' + this.Progress + '%)'
        },
        periodData () {
          // _.isNill -> Null or undefined => return true
          if (_.isNil(this.campaignInfo.campaign_fr_ymd)) return ''

          let frYmd = this.parseDateFormat(this.campaignInfo.campaign_fr_ymd)
          let toYmd = this.parseDateFormat(this.campaignInfo.campaign_to_ymd)
          let text = frYmd + ' ~ ' +
            toYmd + ' ( ' +
            this.live_days + ' / ' +
            this.total_days + ' )'

          return text
        },
        Progress () { // 시작일 부터의 진행률
          let currentDays = this.calDays(this.parseDate(this.ymd.fr), new Date())
          if (currentDays > this.totalDays) currentDays = this.totalDays
          this.live_days = currentDays
          let progress = currentDays / this.totalDays
          progress *= 100
          if (progress > 100) progress = 100
          return progress.toFixed(0)
        },
        status () {
          switch (this.campaignInfo.status) {
            case '2':
              return '진행'
            case '3':
              return '홀딩'
            case '4':
              return '완료'
            case '5':
              return '중간정산'
            default:
              return ''
          }
        },
        totalDays () {
          let res = this.calDays(this.parseDate(this.ymd.fr), this.parseDate(this.ymd.to)) + 1
          this.total_days = res
          return res
        },
        ymd () {
          return {
            fr: this.campaignInfo.campaign_fr_ymd,
            to: this.campaignInfo.campaign_to_ymd
          }
        },
        xlsTableNames () {
          let obj = {
            ad: this.getInfoLength('contract'),
            si: this.getInfoLength('size'),
            cr: this.getInfoLength('creative'),
            cg: this.getInfoLength('creativeGroup'),
            ge: this.getInfoLength('geo')
          }
          let adNames = 'contractTable'
          if (!this.isInterPlay) {
            adNames += '|contractDaysTable'
            for (let i = 0; i < obj.ad; i++) {
              adNames += '|contract' + i
            }
          } else {
            adNames += '|inter_table_base'
            for (let i = 0; i < obj.ad; i++) {
              adNames += '|inter_table_ad' + i
            }
          }

          let sizeNames = 'sizeTable|sizeDaysTable'
          for (let i = 0; i < obj.si; i++) {
            sizeNames += '|size' + i
          }
          let creativeNames = 'creativeTable'
          if (!this.isInterPlay) {
            creativeNames += '|creativeDaysTable'
            for (let i = 0; i < obj.cr; i++) {
              creativeNames += '|creative' + i
            }
          } else {
            for (let i = 0; i < obj.cr; i++) {
              creativeNames += '|inter_table_cr' + i
            }
          }
          let creativeGroupNames = 'creativeGroupTable'
          creativeGroupNames += '|creativeGroupDaysTable'
          for (let i = 0; i < obj.cg; i++) {
            creativeGroupNames += '|creativeGroup' + i
          }
          let geoNames = ''
          if (obj.ge > 0) {
            geoNames = 'geoTable|geoDaysTable'
            for (let i = 0; i < obj.ge; i++) {
              geoNames += '|geo' + i
            }
          }

          let res = [adNames, sizeNames, creativeNames, creativeGroupNames]
          if (geoNames !== '') res.push(geoNames)
          return res
        }
      },
      created () {
        let userType = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_u')))).cust_knd
        this.cust_knd = checkUser(userType)
      },
      watch: {
        campaignInfo (val) {
          if (this.campaignInfo.status === '3') {
            let progress = document.getElementsByClassName('progress-linear__bar__determinate')
            progress[0].style.background = '#d9534f'
          }
          document.getElementById('export_excel').style.display = 'inline-block'
        }
      },
      mounted () {
        this.queryAndIndeterminate()
      },
      beforeDestroy () {
        clearInterval(this.interval)
      }
    }
</script>

<style scoped>
    .camInfoWrapper {
        width: calc(100% - 52px);
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #d1dce3;
        padding: 10px 20px;
        margin-left: 5px;
        margin-right: 5px;
        margin-bottom: 15px;
    }
    .camInfoTop {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        justify-content: space-between;
    }
    .camInfoLeft {
        width: 70%;
    }
    .camInfoRight {
        width: 25%;
        max-width: 280px;
        min-width: 210px;
    }
    .camInfoCompany {
        display: flex;
        justify-content: space-between;
    }

    .campaignName {
        font-size: 17pt;
    }
    .statusText {
        display: inline-block;
        width: 25px;
        margin-right: 10px;
        font-weight: 500;
    }
    .progressInfo {
        display: flex;
        justify-content: space-between;
    }
    .text-blue {
        color: #0000ff;
    }
    .text-red {
        color: #ff0000;
    }
    .text-green {
        color: #00a000;
    }
    .text-black {
        color: #000000;
    }
    .export_excel {
        vertical-align: middle;
        width: 30px;
        height: auto;
        margin-bottom: 3px;
        margin-left: 10px;
        display: none;
    }
    .export_excel:hover {
        cursor: pointer;
    }
    #exportIE {
        display: none;
    }
    @media screen and (max-width: 600px) {
        .camInfoTop {
            width: 100%;
            display: block;
        }
        .camInfoLeft,
        .camInfoRight {
            width: 100%;
            display: inline-block;
        }
        .camInfoRight {
            margin-top: 10px;
            min-width: 100%;
        }
        .campaignName {
            font-size: 15pt;
        }
    }
</style>
<style>
    .progress-linear__bar {
        height: inherit;
        background-color: #ddd;
    }
    .progress-linear__bar__determinate {
        height: inherit;
        background-color: #64bd63;
        transition: 0.3s ease-in;
    }
</style>


// WEBPACK FOOTER //
// CamInfo.vue?32c90e6e